/* eslint-disable react/jsx-no-bind */
import { addVehicle } from "action/garage/addVehicle";
import { openModal } from "action/modal/openModal";
import { AMP_SELECT_VEHICLE_LOCATIONS } from "analytics/amplitude/amplitudeEvents";
import classnames from "classnames";
import PAText, { FONT_SIZE } from "component/design-system/typography/PAText/PAText";
import Collapse from "component/react-bootstrap/Collapse";
import useScreenSize from "hoc/useScreenSize";
import { RootState } from "interfaces/generics.type";
import VehicleIcon from "modules/home/VehicleIcon";
import { useTranslation } from "next-i18next";
import dynamic from "next/dynamic";
import { useState } from "react";
import Skeleton from "react-loading-skeleton";
import { useDispatch, useSelector } from "react-redux";
import { validateVehicle } from "../../../util/vehicle/validate-vehicle";
import GarageDropdown from "../../garage-dropdown/garage-dropdown.component";
import GarageInfo from "./garage-info/GarageInfo";
import styles from "./garage-info/garage-info.module.scss";
import productFilterStyles from "./productFilterVehicle.module.scss";

const BoxedVehicleSelector = dynamic(
  () => import(/* webpackChunkName: "boxed-vehicle-selector-form" */"../../vehicle-form/BoxedVehicleSelector"),
  { loading: () => <Skeleton height={138} />, ssr: false },
);
const GarageList = dynamic(() => import(/* webpackChunkName: "garage-list" */"component/garage-list/garage-list.component"), {
  ssr: false,
});

function ProductFilterVehicle(props) {
  const [inGarage, setInGarage] = useState(false);
  const [isCollapsed, setIsCollapsed] = useState(true);
  const { selectedVehicle } = useSelector((store: RootState) => store.garage);
  const { urlInformation } = useSelector((store: RootState) => store.utils);
  const dispatch = useDispatch();
  const [isMobile] = useScreenSize();
  const { t } = useTranslation(["common", "category-map"]);
  const catMapT = (_: string) => t(_, { ns: "category-map" });

  function toggleGarage() {
    setInGarage(!inGarage);
  }

  function setCollapsedState(collapsed: boolean) {
    setIsCollapsed(collapsed);
  }

  function handleSelectVehicle(vehicle: any) {
    dispatch(addVehicle(vehicle));
  }

  function handleAddVehicleClick() {
    // this.props.clearSelection();
    setInGarage(false);
    dispatch(openModal("vehicleSelector", { addNewVehicle: true }));
  }

  function handleVehicleClick() {
    setInGarage(false);
  }

  function renderForm() {
    const { items, selectionOrder, category } = props;
    return (
      <div className="p-b-15">

        <BoxedVehicleSelector
          defaultYear={items ? items.year : undefined}
          defaultMake={items ? items.make : undefined}
          defaultModel={items ? items.model : undefined}
          selectionOrder={selectionOrder}
          category={category}
          autoScroll={false}
          onSelectVehicle={handleSelectVehicle}
        />
      </div>
    );
  }

  const { className, garageTitle } = props;

  // Todo: remove this check. This should be fixed via CMS
  // example page: https://partsavatar.ca/chevrolet-venture-specialty-parts
  const modifiedGarageTitle = garageTitle?.startsWith("null ") && garageTitle?.substring(4);

  const isValidVehicle = validateVehicle(selectedVehicle);
  const containerClassName = classnames(className, "product-filter-vehicle");

  if (urlInformation?.tier0?.toLowerCase() === "tools & equipment") {
    return (
      <h1
        className={classnames({
          [styles.category_name]: props.hideVehicleSelector,
        })}
        style={{ borderBottom: "0" }}
      >
        {modifiedGarageTitle || garageTitle}
      </h1>
    );
  }

  if (props.hideVehicleSelector) {
    return isValidVehicle ? <GarageInfo garageTitle={modifiedGarageTitle || garageTitle} hideVehicleSelector={props.hideVehicleSelector} />
      : (
        <PAText component="h1" fontSize={FONT_SIZE[5]} className="m-0" bold>
          {modifiedGarageTitle || catMapT(garageTitle)}
        </PAText>
      );
  }
  return (
    <div className={`${containerClassName} ${productFilterStyles.product_filter_vehicle_container}`}>
      {/* {!isValidVehicle && ( */}
      <PAText inlineBlock>
        {modifiedGarageTitle || catMapT(garageTitle)}
      </PAText>
      {/* )} */}
      {!isValidVehicle && renderForm()}

      {isMobile
        ? (
          <>
            {isValidVehicle && <GarageInfo garageTitle={modifiedGarageTitle || garageTitle} />}

            <div style={{ display: "flex", justifyContent: "center" }}>

              <button
                type="button"
                className={classnames("d-flex align-items-center btn btn-action btn-block btn-garage background-blue-v2", {
                  active: inGarage,
                })}
                onClick={toggleGarage}
              >
                {" "}

                <VehicleIcon dark width={25} height={25} className="p-r-5" />

                <span>{t("CHANGE VEHICLE")}</span>

                <i
                  style={{ paddingLeft: "calc(0.5 * var(--safari-root-font, 10px))" }}
                  className={classnames("fa", {
                    "fa-caret-down ": !inGarage,
                    "fa-caret-up": inGarage,
                  })}
                />
              </button>
            </div>

            <Collapse
              in={inGarage}
              onEnter={() => setCollapsedState(false)}
              onExited={() => setCollapsedState(true)}
            >

              <div className="p-t-10">
                <GarageList
                  onAddVehicleClick={handleAddVehicleClick}
                  onVehicleClick={handleVehicleClick}
                  onClose={toggleGarage}
                  isOpen={inGarage || !isCollapsed}
                  loc={AMP_SELECT_VEHICLE_LOCATIONS.CATEGORY_PAGE_FILTER}
                />
              </div>
            </Collapse>
          </>
        )
        : (
          <>
            {isValidVehicle && <GarageInfo garageTitle={garageTitle} />}

            <div className="row row-no-padding">

              <div className="col-xs-12">

                <div className="text-center">

                  <GarageDropdown
                    dropdownId="dropdown-search-garage"
                    toggleButtonClassName="btn-sm btn-block"
                    buttonText={t("CHANGE VEHICLE")}
                    onAddVehicleClick={handleAddVehicleClick}
                    loc={AMP_SELECT_VEHICLE_LOCATIONS.CATEGORY_PAGE_FILTER}
                    darkIcon
                  />
                </div>
              </div>
            </div>
          </>
        ) }
    </div>
  );
}

export default ProductFilterVehicle;
